import { Link } from "react-router-dom";

export function AppFooter({ className = "" }) {
  return (
    <footer
      className={`flex flex-col items-center gap-2 border-t border-border px-4 py-6 text-xs text-brand-mute sm:flex-row sm:justify-center sm:gap-3 ${className}`}
      data-testid="app-footer"
    >
      <span className="whitespace-nowrap">© 2026 Throughline Politics, Inc.</span>
      <span className="hidden sm:inline text-border">·</span>
      <Link
        to="/privacy"
        className="whitespace-nowrap font-medium transition-colors hover:text-brand-red"
        data-testid="footer-privacy-link"
      >
        Privacy Policy
      </Link>
      <span className="text-border">·</span>
      <Link
        to="/terms"
        className="whitespace-nowrap font-medium transition-colors hover:text-brand-red"
        data-testid="footer-terms-link"
      >
        Terms of Use
      </Link>
    </footer>
  );
}
